export default {
      id: "admin-usage",
      viewBox: "0 0 18 19",
      url: __webpack_public_path__ + "icons.svg#admin",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./src/assets/admin.svg
// module id = 285
// module chunks = 0